import { render, staticRenderFns } from "./sortable-th.vue?vue&type=template&id=953c2224"
import script from "./sortable-th.vue?vue&type=script&lang=js"
export * from "./sortable-th.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sipinor/public_html/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('953c2224')) {
      api.createRecord('953c2224', component.options)
    } else {
      api.reload('953c2224', component.options)
    }
    module.hot.accept("./sortable-th.vue?vue&type=template&id=953c2224", function () {
      api.rerender('953c2224', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/sortable-th.vue"
export default component.exports